import * as yup from "yup";
export const change_password_schema = {
  old_password: "",
  new_password: "",
  confirm_password: "",
};

export const change_password_validation_schema = yup.object().shape({
  old_password: yup.string().required("password_required_validation"),
  new_password: yup
    .string()
    .required("new_password_required_validation")
    .min(6, "new_password_length_validation")
    .matches(/^\S*$/, 'enter_valid_password')
    .matches(/[a-z]/, "password_must_have_lowercase")
    .matches(/[A-Z]/, "password_must_have_uppercase")
    .matches(/[0-9]/, "password_must_have_number")
    .notOneOf([yup.ref("old_password")], "password_must_be_different")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "password_must_have_special_character"),
  confirm_password: yup
    .string()
    .required("confirm_new_pssword_required")
    .oneOf([yup.ref("new_password"), null], "same_password_validation"),
});
